import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { initMetaPixel } from './components/utils/MetaPixel';
import { React, useEffect } from "react";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import About from "./components/pages/About";
import Courses from "./components/pages/Courses";
import Contact from "./components/pages/Contact";
import Index from "./components/pages/Index";
import CourseDetail from './components/pages/CourseDetail';
import EbookDetail from './components/pages/EbookDetail';
import CourseDetail001 from './components/pages/CourseDetail001';
import CourseDetail002 from './components/pages/CourseDetail002';
import CourseDetail003 from './components/pages/CourseDetail003';
import CourseDetail004 from './components/pages/CourseDetail004';
import TraffickerServices from './components/pages/TraffickerServices';
import UpsellPage from './components/pages/UpsellPage';
import CoursePlayer from './components/pages/CoursePlayer';
import Success from './components/pages/Success';
import PaymentResponse from './components/pages/PaymentResponse';
import SuccessEbook from './components/pages/SuccessEbook';
import Failure from './components/pages/Failure';
import Pending from './components/pages/Pending';
import Rejected from './components/pages/Rejected';
import ScrollToTop from './components/pages/ScrollToTop';
import { useAuth } from "./context/AuthContext";


function Layout() {
  const location = useLocation();

  // Ocultar Header solo en la página de detalle del curso y en el reproductor de clases
  const hideHeader = location.pathname.startsWith("/course-player") || location.pathname.includes("course-details") || location.pathname.includes("ebook-details") || location.pathname.includes("upsell");

  return (
    <>
      <ScrollToTop />
      {!hideHeader && <Header />}
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/about" element={<About />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/contact" element={<Contact />} />

        {/* Nuevas rutas de detalle según prefijo */}
        <Route path="/course-details/:id" element={<CourseDetail />} />
        <Route path="/ebook-details/:id" element={<EbookDetail />} />
        <Route path="/001/course-details/:id" element={<CourseDetail001 />} />
        <Route path="/002/course-details/:id" element={<CourseDetail002 />} />
        <Route path="/tech/course-details/:id" element={<CourseDetail003 />} />
        <Route path="/tech/course-details-ws/:id" element={<CourseDetail004 />} />
        <Route path="/services/trafficker-services" element={<TraffickerServices />} />
        <Route path="/upsell" element={<UpsellPage />} />
      

        <Route path="/course-player/:id" element={
          <ProtectedRoute>
            <CoursePlayer />
          </ProtectedRoute>
        } />

        <Route path="/payment-response" element={<PaymentResponse />} />
        <Route path="/success" element={<Success />} />
        <Route path="/success-ebook" element={<SuccessEbook />} />
        <Route path="/failure" element={<Failure />} />
        <Route path="/pending" element={<Pending />} />
        <Route path="/rejected" element={<Rejected />} />
      </Routes>
      <Footer />
    </>
  );
}

// Componente para proteger rutas privadas
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Cargando...</div>; // o un loader más bonito
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;
}

function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);

  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
